import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import { connect } from 'react-redux';

import Loader from '../../Loader/Loader';
import CommonListingItems from '../CommonListingItems/CommonListingItems';
import messages from '../../../locale/jsonMessages';
import { isRTL } from '../../../helpers/formatLocale';
import { getDynamicName } from '../../../helpers/GetDynamicItemName/getDynamicName';

import cs from 'swiper/swiper-bundle.css';
import t from '../../../styles/customSwiper.css'
import s from './HomeSlider.css';

const SampleNextArrow = ({ className }) => (
  <div className={className}>
    <svg xmlns="http://www.w3.org/2000/svg" width="10.389" height="18.171" viewBox="0 0 10.389 18.171">
      <path id="Path_42316" data-name="Path 42316" d="M9.3,23.166a1.3,1.3,0,0,1-.921-2.219l6.877-6.864L8.378,7.22a1.3,1.3,0,1,1,1.843-1.842l7.785,7.785a1.3,1.3,0,0,1,0,1.829l-7.785,7.785a1.3,1.3,0,0,1-.921.389Z" transform="translate(-7.994 -4.996)" fill='currentColor' />
    </svg>
  </div>
);

const SamplePrevArrow = ({ className }) => (
  <div className={className}>
    <svg xmlns="http://www.w3.org/2000/svg" width="10.389" height="18.17" viewBox="0 0 10.389 18.17">
      <path id="Path_42317" data-name="Path 42317" d="M17.078,23.166A1.3,1.3,0,0,0,18,20.948l-6.877-6.864L18,7.22a1.3,1.3,0,0,0-1.842-1.842L8.371,13.163a1.3,1.3,0,0,0,0,1.829l7.785,7.785a1.3,1.3,0,0,0,.921.389Z" transform="translate(-7.994 -4.996)" fill='currentColor' />
    </svg>
  </div>
);

function SlideComponent(props) {
  const {
    data = [],
    similarClassName,
    similiarListPadding,
    fromPage,
    isEditWishList,
    className,
    intl,
    paginationNextClass,
    paginationPrevClass,
    isViewProfile,
    dynamicLanguageData
  } = props;

  const { locale, formatMessage } = intl;
  const [load, setLoad] = useState(false);
  const loadSyncRef = useRef();
  const [SwiperComponents, setSwiperComponents] = useState({ Swiper: null, SwiperSlide: null, Navigation: null });
  const rtl = isRTL(locale);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const swiperReact = require('swiper/react');
      const swiperModules = require('swiper/modules');
      setSwiperComponents({
        Swiper: swiperReact.Swiper,
        SwiperSlide: swiperReact.SwiperSlide,
        Navigation: swiperModules.Navigation
      });
      setLoad(true);
    }
  }, []);

  useEffect(() => {
    return () => clearTimeout(loadSyncRef.current);
  }, []);

  useEffect(() => {
    setLoad(false);
    clearTimeout(loadSyncRef.current);
    loadSyncRef.current = setTimeout(() => {
      setLoad(true);
    }, 1);
  }, [locale]);


  const {
    Swiper,
    SwiperSlide,
    Navigation
  } = SwiperComponents;

  const params = {
    spaceBetween: 25,
    modules: [Navigation],
    navigation: {
      nextEl: (fromPage === 'viewProfile') ? `.viewProfileSwiperNavigationNextBtn` : `.${paginationNextClass}`,
      prevEl: (fromPage === 'viewProfile') ? `.viewProfileSwiperNavigationPrevBtn` : `.${paginationPrevClass}`,
    },
    breakpoints: {
      320: { slidesPerView: 1 },
      641: { slidesPerView: 2 },
      768: { slidesPerView: 2 },
      992: { slidesPerView: fromPage === 'viewProfile' ? 2 : 3 },
      1200: { slidesPerView: fromPage === 'viewProfile' ? 2 : 4 },
    }
    // if change breakpoint also change skeleton css breakpoint in app-common.css
  };

  return (
    <Row className={cx(className)}>
      <Col xs={12} sm={12} md={12} lg={12} className={similarClassName}>
        <div className={s.homeSlickSliderContainer}>
          {!load && <Loader type="text" />}
          {
            load && Swiper && SwiperSlide &&
            <Swiper
              {...params}
              key={rtl} // force remount on language change
              dir={rtl ? 'rtl' : 'ltr'}
              className={cx('row', s.noMargin)}
            >
              {
                data.map((item, index) => {
                  if (!item?.listPhotos?.length) return null;

                  const carType = item?.settingsData[0]?.listsettings?.itemName;
                  const transmission = item?.transmission;
                  const isListOwner = item?.isListOwner;
                  const transmissionLabel = transmission === '1'
                    ? formatMessage(messages.automatic)
                    : formatMessage(messages.manual);

                  const starRatingValue =
                    item?.reviewsCount > 0 && item?.reviewsStarRating > 0
                      ? Math.round(item.reviewsStarRating / item.reviewsCount)
                      : 0;
                  let dynamicCarType = getDynamicName({ value: item?.settingsData[0]?.listsettings, locale, data: dynamicLanguageData });

                  return (
                    <SwiperSlide key={index}>
                      <div className={cx(s.background, s.positionRelative, similiarListPadding)}>
                        <CommonListingItems
                          id={item?.id}
                          isChecked={Boolean(item?.wishListStatus)}
                          isEditWishList={isEditWishList}
                          title={item?.title}
                          listPhotos={item?.listPhotos}
                          coverPhoto={item?.coverPhoto}
                          bookingType={item?.bookingType}
                          basePrice={item?.listingData?.basePrice}
                          currency={item?.listingData?.currency}
                          reviewsCount={item?.reviewsCount}
                          carType={dynamicCarType?.itemName || carType}
                          transmissionLabel={transmissionLabel}
                          isListOwner={isListOwner}
                          userId={item?.userId}
                          starRatingValue={starRatingValue}
                          isViewProfile={isViewProfile}
                        />
                      </div>
                    </SwiperSlide>
                  );
                })
              }
            </Swiper>
          }
          {
            load && <div className="homeSwiperArrowContainer">
              <SampleNextArrow className={cx('commonSwiperNavigationBtn', (fromPage === 'viewProfile') ? `viewProfileSwiperNavigationNextBtn` : paginationNextClass)} />
              <SamplePrevArrow className={cx('commonSwiperNavigationBtn', (fromPage === 'viewProfile') ? `viewProfileSwiperNavigationPrevBtn` : paginationPrevClass)} />
            </div>
          }
        </div>
      </Col>
    </Row>
  );
}

SlideComponent.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    listPhotos: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string
    })),
    coverPhoto: PropTypes.number,
    listingData: PropTypes.shape({
      basePrice: PropTypes.number,
      currency: PropTypes.string,
    }),
    settingsData: PropTypes.arrayOf(PropTypes.shape({
      listsettings: PropTypes.shape({
        itemName: PropTypes.string,
      }),
    })),
    id: PropTypes.number,
    beds: PropTypes.number,
    title: PropTypes.string,
    bookingType: PropTypes.string,
    reviewsCount: PropTypes.number,
    reviewsStarRating: PropTypes.number
  }))
};

const mapState = (state) => ({
  dynamicLanguageData: state?.dynamicListSettings?.data
});
const mapDispatch = {};

export default injectIntl(withStyles(cs, t, s)(connect(mapState, mapDispatch)(SlideComponent)));
